module.exports = __webpack_public_path__ + "static/media/gladys3.63d76c1c.mp3";